import ApiClient from './apiClient'
import {
  DedicatedIpAssignmentDetails, DedicatedListResponse, DedicatedServer, DedicatedUser, PaginatedDedicatedList,
} from '../pages/dedicated-servers/types'

export type DedicatedServersQueries = {
  page?: number | null;
  page_size?: number | null;
  ordering?: string | null;
  search?: string | null;
  filtering?: string | null;
  dedicated_user?: string | null;
  deleted?: string | boolean | null;
  external_id?: number | null;
  external_user_id?: number | null;
  external_tags?: string | null;
  is_assigned?: string | boolean | null;
  power_status?: string | null;
  server_type?: string | null;
  disabled?: string | boolean | null;
  disabled_reason?: string | null;
  service__client?: number | null;
  ip?: string | null;
  is_primary?: string | boolean | null;
  server?: string | null;
  server__dedicated_user?: string | null;
  server__external_user_id?: number | null;
  subnet?: string | null;
}

const getList = async <T>(resource: string, params: DedicatedServersQueries, signal?: AbortSignal) => {
  const response = await ApiClient.get<DedicatedListResponse<T>>(`dedicated-servers/${resource}`, { params, signal })
  // The live API returns objects; results remains a fallback for the documented envelope.
  const objects = response.data.objects ?? response.data.results ?? []
  const data: PaginatedDedicatedList<T> = {
    ...response.data,
    objects,
    count: response.data.count ?? response.data.totalCount ?? objects.length,
    next: response.data.next ?? null,
    previous: response.data.previous ?? null,
  }
  return { ...response, data }
}

const dedicatedServersService = {
  getServers: (params: DedicatedServersQueries, signal?: AbortSignal) =>
    getList<DedicatedServer>('servers', params, signal),

  getServer: (id: string, signal?: AbortSignal) =>
    ApiClient.get<DedicatedServer>(`dedicated-servers/servers/${id}`, { signal }),

  syncServer: (id: string) =>
    ApiClient.post(`dedicated-servers/servers/${id}/sync`, {}),

  syncAllServers: () =>
    ApiClient.post('dedicated-servers/servers/sync_all', {}),

  getUsers: (params: DedicatedServersQueries, signal?: AbortSignal) =>
    getList<DedicatedUser>('users', params, signal),

  getUser: (id: string, signal?: AbortSignal) =>
    ApiClient.get<DedicatedUser>(`dedicated-servers/users/${id}`, { signal }),

  getIpAssignments: (params: DedicatedServersQueries, signal?: AbortSignal) =>
    getList<DedicatedIpAssignmentDetails>('ips', params, signal),

  getIpAssignment: (id: string, signal?: AbortSignal) =>
    ApiClient.get<DedicatedIpAssignmentDetails>(`dedicated-servers/ips/${id}`, { signal }),
}

export default dedicatedServersService
